module.exports = __webpack_public_path__ + "img/tel3.df1cf4d4.jpg";